import Image from 'next/image'

import { Button } from '@/components/ui/button'
import { WebFooter } from '@/components/web-footer'
import { useRouter } from 'next/router'

interface ChallengeLayoutProps {
  children: React.ReactNode
  showBackButton?: boolean
}

export const ChallengeLayout = (props: ChallengeLayoutProps): JSX.Element => {
  const router = useRouter()
  return (
    <main className="flex min-h-screen flex-col bg-basic-bg">
      <header className="flex h-[50px] items-center bg-white px-[10px] md:h-[60px] md:px-[24px] lg:h-[70px]">
        <div className="flex-1">
          <Image
            src="/logiq-challenge-logo.svg"
            width={115}
            height={33}
            className="md:h-[44px] md:w-[153px]"
            alt="LogiQlabo Challenge"
          />
        </div>
        <div className="flex-1"></div>
        <div className="relative flex flex-1 justify-end">
          {props.showBackButton && (
            <Button
              className="h-[38px] w-[153px] bg-[#F9F9F9] px-[10px] text-[11px] tracking-widest text-[#1469A1] lg:h-[48px] lg:w-[218px] lg:text-sm"
              onClick={router.back}
            >
              ロジックラボ会員ページ
            </Button>
          )}
        </div>
      </header>
      <div className="grow">{props.children}</div>

      <WebFooter />
    </main>
  )
}
